import { DelugeId } from '@root/entities/user-short'

import type { ArchivedPremiumDto } from './premium-meta'
import type { ServicesApi } from '@root/shared/api'
import type { AvatarsHost } from '@root/shared/models/AvatarsHost'

export interface PremiumOwner {
  delugeId: DelugeId
  username: string | undefined
  avatarUrl: string | undefined
}

export const fromDto = (
  dto: ServicesApi.PremiumMetaDto | ArchivedPremiumDto,
  avatarsHost: AvatarsHost,
) => {
  if (!dto.ownerDelugeId) {
    return undefined
  }
  return {
    delugeId: DelugeId(dto.ownerDelugeId),
    username: dto.ownerUsername,
    avatarUrl: dto.ownerAvatarSrc
      ? `${avatarsHost}/${dto.ownerAvatarSrc}`
      : undefined,
  }
}
